/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as sharedRouteRouteImport } from './../../routes/(shared)/route'
import { Route as publicRouteRouteImport } from './../../routes/(public)/route'
import { Route as practitionerRouteRouteImport } from './../../routes/(practitioner)/route'
import { Route as patientRouteRouteImport } from './../../routes/(patient)/route'
import { Route as anonymousRouteRouteImport } from './../../routes/(anonymous)/route'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as sharedProfileRouteImport } from './../../routes/(shared)/profile'
import { Route as sharedNotificationsRouteImport } from './../../routes/(shared)/notifications'
import { Route as sharedLogoutRouteImport } from './../../routes/(shared)/logout'
import { Route as sharedHomeRouteImport } from './../../routes/(shared)/home'
import { Route as sharedContactRouteImport } from './../../routes/(shared)/contact'
import { Route as sharedBackupRouteImport } from './../../routes/(shared)/backup'
import { Route as sharedAuditLogRouteImport } from './../../routes/(shared)/audit-log'
import { Route as publicSupportRouteImport } from './../../routes/(public)/support'
import { Route as publicLegalRouteImport } from './../../routes/(public)/legal'
import { Route as practitionerPatientsRouteImport } from './../../routes/(practitioner)/patients'
import { Route as practitionerDiagnosticReportsRouteImport } from './../../routes/(practitioner)/diagnostic-reports'
import { Route as practitionerCompanyRouteImport } from './../../routes/(practitioner)/company'
import { Route as patientEncountersRouteImport } from './../../routes/(patient)/encounters'
import { Route as patientDocumentsRouteImport } from './../../routes/(patient)/documents'
import { Route as patientDiagnosticReportsRouteImport } from './../../routes/(patient)/diagnostic-reports'
import { Route as anonymousResetPasswordRouteImport } from './../../routes/(anonymous)/reset-password'
import { Route as anonymousRegisterRouteImport } from './../../routes/(anonymous)/register'
import { Route as anonymousRecoverPasswordRouteImport } from './../../routes/(anonymous)/recover-password'
import { Route as anonymousPatientSignupRouteImport } from './../../routes/(anonymous)/patient-signup'
import { Route as anonymousLoginRouteImport } from './../../routes/(anonymous)/login'
import { Route as anonymousConfirmAccountRouteImport } from './../../routes/(anonymous)/confirm-account'
import { Route as anonymousConfirmRouteImport } from './../../routes/(anonymous)/confirm'
import { Route as anonymousAppHomeRouteImport } from './../../routes/(anonymous)/app-home'
import { Route as publicDisableEmailsTokenRouteImport } from './../../routes/(public)/disable-emails/$token'
import { Route as practitionerPractitionerWorkListRouteImport } from './../../routes/(practitioner)/practitioner/work-list'
import { Route as practitionerPractitionerQuickDiagnosticReportRequestRouteImport } from './../../routes/(practitioner)/practitioner/quick-diagnostic-report-request'
import { Route as practitionerPractitionerPatientPaymentOrdersRouteImport } from './../../routes/(practitioner)/practitioner/patient-payment-orders'
import { Route as practitionerPractitionerDiagnosticReportSentRouteImport } from './../../routes/(practitioner)/practitioner/diagnostic-report-sent'
import { Route as practitionerPractitionerDiagnosticReportRequestRouteImport } from './../../routes/(practitioner)/practitioner/diagnostic-report-request'
import { Route as practitionerPractitionerActivityRouteImport } from './../../routes/(practitioner)/practitioner/activity'
import { Route as practitionerPatientsCreateRouteImport } from './../../routes/(practitioner)/patients/create'
import { Route as practitionerPatientsPatientIdRouteImport } from './../../routes/(practitioner)/patients/$patientId'
import { Route as practitionerImageProtocolImageProtocolRequestRouteImport } from './../../routes/(practitioner)/image-protocol/image-protocol-request'
import { Route as practitionerCompanyPractitionersRouteImport } from './../../routes/(practitioner)/company/practitioners'
import { Route as practitionerCompanyPathologyCustomizationRouteImport } from './../../routes/(practitioner)/company/pathology-customization'
import { Route as practitionerCompanyMetricsRouteImport } from './../../routes/(practitioner)/company/metrics'
import { Route as practitionerCompanyInactiveCompanyRouteImport } from './../../routes/(practitioner)/company/inactive-company'
import { Route as patientPatientPsoriasisInfoRouteImport } from './../../routes/(patient)/patient/psoriasis-info'
import { Route as patientPatientPaymentOrdersRouteImport } from './../../routes/(patient)/patient/payment-orders'
import { Route as patientPatientImageProtocolsRouteImport } from './../../routes/(patient)/patient/image-protocols'
import { Route as patientPatientImageProtocolRequestRouteImport } from './../../routes/(patient)/patient/image-protocol-request'
import { Route as patientPatientDiagnosticReportSentRouteImport } from './../../routes/(patient)/patient/diagnostic-report-sent'
import { Route as patientPatientDiagnosticReportRequestRouteImport } from './../../routes/(patient)/patient/diagnostic-report-request'
import { Route as patientDocumentsCreateRouteImport } from './../../routes/(patient)/documents/create'
import { Route as patientDiagnosticReportsDiagnosticReportIdRouteImport } from './../../routes/(patient)/diagnostic-reports/$diagnosticReportId'
import { Route as practitionerPractitionersPractitionerIdRecoverPasswordRouteImport } from './../../routes/(practitioner)/practitioners/$practitionerId/recover-password'
import { Route as practitionerPractitionerPatientPaymentOrdersCreateRouteImport } from './../../routes/(practitioner)/practitioner/patient-payment-orders/create'
import { Route as practitionerPractitionerActivityDateRouteImport } from './../../routes/(practitioner)/practitioner/activity/$date'
import { Route as practitionerPatientsPatientIdTerminateStudyRouteImport } from './../../routes/(practitioner)/patients/$patientId/terminate-study'
import { Route as practitionerPatientsPatientIdRecoverPasswordRouteImport } from './../../routes/(practitioner)/patients/$patientId/recover-password'
import { Route as practitionerPatientsPatientIdPatientInteractionsRouteImport } from './../../routes/(practitioner)/patients/$patientId/patient-interactions'
import { Route as practitionerPatientsPatientIdDeleteRouteImport } from './../../routes/(practitioner)/patients/$patientId/delete'
import { Route as practitionerCompanyPractitionersCreateRouteImport } from './../../routes/(practitioner)/company/practitioners/create'
import { Route as practitionerCompanyPractitionersPractitionerIdRouteImport } from './../../routes/(practitioner)/company/practitioners/$practitionerId'
import { Route as practitionerCompanyPathologyCustomizationCreateRouteImport } from './../../routes/(practitioner)/company/pathology-customization/create'
import { Route as practitionerPatientsPatientIdTemporaryImagesUploadRouteImport } from './../../routes/(practitioner)/patients/$patientId/temporary-images/upload'
import { Route as practitionerPatientsPatientIdImageProtocolsImageProtocolIdRouteImport } from './../../routes/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId'
import { Route as practitionerPatientsPatientIdEncountersEncounterIdRouteImport } from './../../routes/(practitioner)/patients/$patientId/encounters/$encounterId'
import { Route as practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRouteImport } from './../../routes/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId'
import { Route as practitionerCompanyPractitionersPractitionerIdDeleteRouteImport } from './../../routes/(practitioner)/company/practitioners/$practitionerId/delete'
import { Route as practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRouteImport } from './../../routes/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete'
import { Route as practitionerCompanyPathologyCustomizationPathologyIdEditRouteImport } from './../../routes/(practitioner)/company/pathology-customization/$pathologyId/edit'
import { Route as patientPatientPaymentOrdersPaymentOrderIdPayRouteImport } from './../../routes/(patient)/patient/payment-orders/$paymentOrderId/pay'

const sharedRouteRoute = sharedRouteRouteImport.update({
  id: '/(shared)',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const practitionerRouteRoute = practitionerRouteRouteImport.update({
  id: '/(practitioner)',
  getParentRoute: () => rootRouteImport,
} as any)
const patientRouteRoute = patientRouteRouteImport.update({
  id: '/(patient)',
  getParentRoute: () => rootRouteImport,
} as any)
const anonymousRouteRoute = anonymousRouteRouteImport.update({
  id: '/(anonymous)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const sharedProfileRoute = sharedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedNotificationsRoute = sharedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedLogoutRoute = sharedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedHomeRoute = sharedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedContactRoute = sharedContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedBackupRoute = sharedBackupRouteImport.update({
  id: '/backup',
  path: '/backup',
  getParentRoute: () => sharedRouteRoute,
} as any)
const sharedAuditLogRoute = sharedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => sharedRouteRoute,
} as any)
const publicSupportRoute = publicSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicLegalRoute = publicLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => publicRouteRoute,
} as any)
const practitionerPatientsRoute = practitionerPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => practitionerRouteRoute,
} as any)
const practitionerDiagnosticReportsRoute =
  practitionerDiagnosticReportsRouteImport.update({
    id: '/diagnostic-reports',
    path: '/diagnostic-reports',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerCompanyRoute = practitionerCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => practitionerRouteRoute,
} as any)
const patientEncountersRoute = patientEncountersRouteImport.update({
  id: '/encounters',
  path: '/encounters',
  getParentRoute: () => patientRouteRoute,
} as any)
const patientDocumentsRoute = patientDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => patientRouteRoute,
} as any)
const patientDiagnosticReportsRoute =
  patientDiagnosticReportsRouteImport.update({
    id: '/diagnostic-reports',
    path: '/diagnostic-reports',
    getParentRoute: () => patientRouteRoute,
  } as any)
const anonymousResetPasswordRoute = anonymousResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousRegisterRoute = anonymousRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousRecoverPasswordRoute =
  anonymousRecoverPasswordRouteImport.update({
    id: '/recover-password',
    path: '/recover-password',
    getParentRoute: () => anonymousRouteRoute,
  } as any)
const anonymousPatientSignupRoute = anonymousPatientSignupRouteImport.update({
  id: '/patient-signup',
  path: '/patient-signup',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousLoginRoute = anonymousLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousConfirmAccountRoute = anonymousConfirmAccountRouteImport.update({
  id: '/confirm-account',
  path: '/confirm-account',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousConfirmRoute = anonymousConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const anonymousAppHomeRoute = anonymousAppHomeRouteImport.update({
  id: '/app-home',
  path: '/app-home',
  getParentRoute: () => anonymousRouteRoute,
} as any)
const publicDisableEmailsTokenRoute =
  publicDisableEmailsTokenRouteImport.update({
    id: '/disable-emails/$token',
    path: '/disable-emails/$token',
    getParentRoute: () => publicRouteRoute,
  } as any)
const practitionerPractitionerWorkListRoute =
  practitionerPractitionerWorkListRouteImport.update({
    id: '/practitioner/work-list',
    path: '/practitioner/work-list',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerQuickDiagnosticReportRequestRoute =
  practitionerPractitionerQuickDiagnosticReportRequestRouteImport.update({
    id: '/practitioner/quick-diagnostic-report-request',
    path: '/practitioner/quick-diagnostic-report-request',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerPatientPaymentOrdersRoute =
  practitionerPractitionerPatientPaymentOrdersRouteImport.update({
    id: '/practitioner/patient-payment-orders',
    path: '/practitioner/patient-payment-orders',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerDiagnosticReportSentRoute =
  practitionerPractitionerDiagnosticReportSentRouteImport.update({
    id: '/practitioner/diagnostic-report-sent',
    path: '/practitioner/diagnostic-report-sent',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerDiagnosticReportRequestRoute =
  practitionerPractitionerDiagnosticReportRequestRouteImport.update({
    id: '/practitioner/diagnostic-report-request',
    path: '/practitioner/diagnostic-report-request',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerActivityRoute =
  practitionerPractitionerActivityRouteImport.update({
    id: '/practitioner/activity',
    path: '/practitioner/activity',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPatientsCreateRoute =
  practitionerPatientsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerPatientsRoute,
  } as any)
const practitionerPatientsPatientIdRoute =
  practitionerPatientsPatientIdRouteImport.update({
    id: '/$patientId',
    path: '/$patientId',
    getParentRoute: () => practitionerPatientsRoute,
  } as any)
const practitionerImageProtocolImageProtocolRequestRoute =
  practitionerImageProtocolImageProtocolRequestRouteImport.update({
    id: '/image-protocol/image-protocol-request',
    path: '/image-protocol/image-protocol-request',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerCompanyPractitionersRoute =
  practitionerCompanyPractitionersRouteImport.update({
    id: '/practitioners',
    path: '/practitioners',
    getParentRoute: () => practitionerCompanyRoute,
  } as any)
const practitionerCompanyPathologyCustomizationRoute =
  practitionerCompanyPathologyCustomizationRouteImport.update({
    id: '/pathology-customization',
    path: '/pathology-customization',
    getParentRoute: () => practitionerCompanyRoute,
  } as any)
const practitionerCompanyMetricsRoute =
  practitionerCompanyMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => practitionerCompanyRoute,
  } as any)
const practitionerCompanyInactiveCompanyRoute =
  practitionerCompanyInactiveCompanyRouteImport.update({
    id: '/inactive-company',
    path: '/inactive-company',
    getParentRoute: () => practitionerCompanyRoute,
  } as any)
const patientPatientPsoriasisInfoRoute =
  patientPatientPsoriasisInfoRouteImport.update({
    id: '/patient/psoriasis-info',
    path: '/patient/psoriasis-info',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientPatientPaymentOrdersRoute =
  patientPatientPaymentOrdersRouteImport.update({
    id: '/patient/payment-orders',
    path: '/patient/payment-orders',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientPatientImageProtocolsRoute =
  patientPatientImageProtocolsRouteImport.update({
    id: '/patient/image-protocols',
    path: '/patient/image-protocols',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientPatientImageProtocolRequestRoute =
  patientPatientImageProtocolRequestRouteImport.update({
    id: '/patient/image-protocol-request',
    path: '/patient/image-protocol-request',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientPatientDiagnosticReportSentRoute =
  patientPatientDiagnosticReportSentRouteImport.update({
    id: '/patient/diagnostic-report-sent',
    path: '/patient/diagnostic-report-sent',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientPatientDiagnosticReportRequestRoute =
  patientPatientDiagnosticReportRequestRouteImport.update({
    id: '/patient/diagnostic-report-request',
    path: '/patient/diagnostic-report-request',
    getParentRoute: () => patientRouteRoute,
  } as any)
const patientDocumentsCreateRoute = patientDocumentsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => patientDocumentsRoute,
} as any)
const patientDiagnosticReportsDiagnosticReportIdRoute =
  patientDiagnosticReportsDiagnosticReportIdRouteImport.update({
    id: '/$diagnosticReportId',
    path: '/$diagnosticReportId',
    getParentRoute: () => patientDiagnosticReportsRoute,
  } as any)
const practitionerPractitionersPractitionerIdRecoverPasswordRoute =
  practitionerPractitionersPractitionerIdRecoverPasswordRouteImport.update({
    id: '/practitioners/$practitionerId/recover-password',
    path: '/practitioners/$practitionerId/recover-password',
    getParentRoute: () => practitionerRouteRoute,
  } as any)
const practitionerPractitionerPatientPaymentOrdersCreateRoute =
  practitionerPractitionerPatientPaymentOrdersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerPractitionerPatientPaymentOrdersRoute,
  } as any)
const practitionerPractitionerActivityDateRoute =
  practitionerPractitionerActivityDateRouteImport.update({
    id: '/$date',
    path: '/$date',
    getParentRoute: () => practitionerPractitionerActivityRoute,
  } as any)
const practitionerPatientsPatientIdTerminateStudyRoute =
  practitionerPatientsPatientIdTerminateStudyRouteImport.update({
    id: '/terminate-study',
    path: '/terminate-study',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdRecoverPasswordRoute =
  practitionerPatientsPatientIdRecoverPasswordRouteImport.update({
    id: '/recover-password',
    path: '/recover-password',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdPatientInteractionsRoute =
  practitionerPatientsPatientIdPatientInteractionsRouteImport.update({
    id: '/patient-interactions',
    path: '/patient-interactions',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdDeleteRoute =
  practitionerPatientsPatientIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerCompanyPractitionersCreateRoute =
  practitionerCompanyPractitionersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerCompanyPractitionersRoute,
  } as any)
const practitionerCompanyPractitionersPractitionerIdRoute =
  practitionerCompanyPractitionersPractitionerIdRouteImport.update({
    id: '/$practitionerId',
    path: '/$practitionerId',
    getParentRoute: () => practitionerCompanyPractitionersRoute,
  } as any)
const practitionerCompanyPathologyCustomizationCreateRoute =
  practitionerCompanyPathologyCustomizationCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerCompanyPathologyCustomizationRoute,
  } as any)
const practitionerPatientsPatientIdTemporaryImagesUploadRoute =
  practitionerPatientsPatientIdTemporaryImagesUploadRouteImport.update({
    id: '/temporary-images/upload',
    path: '/temporary-images/upload',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute =
  practitionerPatientsPatientIdImageProtocolsImageProtocolIdRouteImport.update({
    id: '/image-protocols/$imageProtocolId',
    path: '/image-protocols/$imageProtocolId',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdEncountersEncounterIdRoute =
  practitionerPatientsPatientIdEncountersEncounterIdRouteImport.update({
    id: '/encounters/$encounterId',
    path: '/encounters/$encounterId',
    getParentRoute: () => practitionerPatientsPatientIdRoute,
  } as any)
const practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute =
  practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRouteImport.update(
    {
      id: '/diagnostic-report/$diagnosticReportId',
      path: '/diagnostic-report/$diagnosticReportId',
      getParentRoute: () => practitionerPatientsPatientIdRoute,
    } as any,
  )
const practitionerCompanyPractitionersPractitionerIdDeleteRoute =
  practitionerCompanyPractitionersPractitionerIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => practitionerCompanyPractitionersPractitionerIdRoute,
  } as any)
const practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute =
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRouteImport.update(
    {
      id: '/pathology-overrides/$pathologyOverrideId/delete',
      path: '/pathology-overrides/$pathologyOverrideId/delete',
      getParentRoute: () => practitionerCompanyRoute,
    } as any,
  )
const practitionerCompanyPathologyCustomizationPathologyIdEditRoute =
  practitionerCompanyPathologyCustomizationPathologyIdEditRouteImport.update({
    id: '/$pathologyId/edit',
    path: '/$pathologyId/edit',
    getParentRoute: () => practitionerCompanyPathologyCustomizationRoute,
  } as any)
const patientPatientPaymentOrdersPaymentOrderIdPayRoute =
  patientPatientPaymentOrdersPaymentOrderIdPayRouteImport.update({
    id: '/$paymentOrderId/pay',
    path: '/$paymentOrderId/pay',
    getParentRoute: () => patientPatientPaymentOrdersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app-home': typeof anonymousAppHomeRoute
  '/confirm': typeof anonymousConfirmRoute
  '/confirm-account': typeof anonymousConfirmAccountRoute
  '/login': typeof anonymousLoginRoute
  '/patient-signup': typeof anonymousPatientSignupRoute
  '/recover-password': typeof anonymousRecoverPasswordRoute
  '/register': typeof anonymousRegisterRoute
  '/reset-password': typeof anonymousResetPasswordRoute
  '/diagnostic-reports': typeof practitionerDiagnosticReportsRoute
  '/documents': typeof patientDocumentsRouteWithChildren
  '/encounters': typeof patientEncountersRoute
  '/company': typeof practitionerCompanyRouteWithChildren
  '/patients': typeof practitionerPatientsRouteWithChildren
  '/legal': typeof publicLegalRoute
  '/support': typeof publicSupportRoute
  '/audit-log': typeof sharedAuditLogRoute
  '/backup': typeof sharedBackupRoute
  '/contact': typeof sharedContactRoute
  '/home': typeof sharedHomeRoute
  '/logout': typeof sharedLogoutRoute
  '/notifications': typeof sharedNotificationsRoute
  '/profile': typeof sharedProfileRoute
  '/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute
  '/documents/create': typeof patientDocumentsCreateRoute
  '/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute
  '/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute
  '/patient/image-protocol-request': typeof patientPatientImageProtocolRequestRoute
  '/patient/image-protocols': typeof patientPatientImageProtocolsRoute
  '/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren
  '/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute
  '/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute
  '/company/metrics': typeof practitionerCompanyMetricsRoute
  '/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren
  '/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren
  '/image-protocol/image-protocol-request': typeof practitionerImageProtocolImageProtocolRequestRoute
  '/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren
  '/patients/create': typeof practitionerPatientsCreateRoute
  '/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren
  '/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute
  '/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute
  '/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren
  '/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute
  '/practitioner/work-list': typeof practitionerPractitionerWorkListRoute
  '/disable-emails/$token': typeof publicDisableEmailsTokenRoute
  '/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute
  '/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren
  '/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute
  '/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute
  '/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute
  '/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute
  '/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute
  '/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute
  '/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute
  '/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute
  '/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute
  '/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute
  '/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute
  '/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute
  '/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute
  '/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute
  '/patients/$patientId/image-protocols/$imageProtocolId': typeof practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute
  '/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app-home': typeof anonymousAppHomeRoute
  '/confirm': typeof anonymousConfirmRoute
  '/confirm-account': typeof anonymousConfirmAccountRoute
  '/login': typeof anonymousLoginRoute
  '/patient-signup': typeof anonymousPatientSignupRoute
  '/recover-password': typeof anonymousRecoverPasswordRoute
  '/register': typeof anonymousRegisterRoute
  '/reset-password': typeof anonymousResetPasswordRoute
  '/diagnostic-reports': typeof practitionerDiagnosticReportsRoute
  '/documents': typeof patientDocumentsRouteWithChildren
  '/encounters': typeof patientEncountersRoute
  '/company': typeof practitionerCompanyRouteWithChildren
  '/patients': typeof practitionerPatientsRouteWithChildren
  '/legal': typeof publicLegalRoute
  '/support': typeof publicSupportRoute
  '/audit-log': typeof sharedAuditLogRoute
  '/backup': typeof sharedBackupRoute
  '/contact': typeof sharedContactRoute
  '/home': typeof sharedHomeRoute
  '/logout': typeof sharedLogoutRoute
  '/notifications': typeof sharedNotificationsRoute
  '/profile': typeof sharedProfileRoute
  '/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute
  '/documents/create': typeof patientDocumentsCreateRoute
  '/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute
  '/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute
  '/patient/image-protocol-request': typeof patientPatientImageProtocolRequestRoute
  '/patient/image-protocols': typeof patientPatientImageProtocolsRoute
  '/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren
  '/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute
  '/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute
  '/company/metrics': typeof practitionerCompanyMetricsRoute
  '/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren
  '/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren
  '/image-protocol/image-protocol-request': typeof practitionerImageProtocolImageProtocolRequestRoute
  '/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren
  '/patients/create': typeof practitionerPatientsCreateRoute
  '/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren
  '/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute
  '/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute
  '/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren
  '/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute
  '/practitioner/work-list': typeof practitionerPractitionerWorkListRoute
  '/disable-emails/$token': typeof publicDisableEmailsTokenRoute
  '/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute
  '/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren
  '/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute
  '/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute
  '/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute
  '/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute
  '/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute
  '/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute
  '/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute
  '/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute
  '/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute
  '/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute
  '/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute
  '/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute
  '/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute
  '/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute
  '/patients/$patientId/image-protocols/$imageProtocolId': typeof practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute
  '/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(anonymous)': typeof anonymousRouteRouteWithChildren
  '/(patient)': typeof patientRouteRouteWithChildren
  '/(practitioner)': typeof practitionerRouteRouteWithChildren
  '/(public)': typeof publicRouteRouteWithChildren
  '/(shared)': typeof sharedRouteRouteWithChildren
  '/(anonymous)/app-home': typeof anonymousAppHomeRoute
  '/(anonymous)/confirm': typeof anonymousConfirmRoute
  '/(anonymous)/confirm-account': typeof anonymousConfirmAccountRoute
  '/(anonymous)/login': typeof anonymousLoginRoute
  '/(anonymous)/patient-signup': typeof anonymousPatientSignupRoute
  '/(anonymous)/recover-password': typeof anonymousRecoverPasswordRoute
  '/(anonymous)/register': typeof anonymousRegisterRoute
  '/(anonymous)/reset-password': typeof anonymousResetPasswordRoute
  '/(patient)/diagnostic-reports': typeof patientDiagnosticReportsRouteWithChildren
  '/(patient)/documents': typeof patientDocumentsRouteWithChildren
  '/(patient)/encounters': typeof patientEncountersRoute
  '/(practitioner)/company': typeof practitionerCompanyRouteWithChildren
  '/(practitioner)/diagnostic-reports': typeof practitionerDiagnosticReportsRoute
  '/(practitioner)/patients': typeof practitionerPatientsRouteWithChildren
  '/(public)/legal': typeof publicLegalRoute
  '/(public)/support': typeof publicSupportRoute
  '/(shared)/audit-log': typeof sharedAuditLogRoute
  '/(shared)/backup': typeof sharedBackupRoute
  '/(shared)/contact': typeof sharedContactRoute
  '/(shared)/home': typeof sharedHomeRoute
  '/(shared)/logout': typeof sharedLogoutRoute
  '/(shared)/notifications': typeof sharedNotificationsRoute
  '/(shared)/profile': typeof sharedProfileRoute
  '/(patient)/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute
  '/(patient)/documents/create': typeof patientDocumentsCreateRoute
  '/(patient)/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute
  '/(patient)/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute
  '/(patient)/patient/image-protocol-request': typeof patientPatientImageProtocolRequestRoute
  '/(patient)/patient/image-protocols': typeof patientPatientImageProtocolsRoute
  '/(patient)/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren
  '/(patient)/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute
  '/(practitioner)/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute
  '/(practitioner)/company/metrics': typeof practitionerCompanyMetricsRoute
  '/(practitioner)/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren
  '/(practitioner)/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren
  '/(practitioner)/image-protocol/image-protocol-request': typeof practitionerImageProtocolImageProtocolRequestRoute
  '/(practitioner)/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren
  '/(practitioner)/patients/create': typeof practitionerPatientsCreateRoute
  '/(practitioner)/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren
  '/(practitioner)/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute
  '/(practitioner)/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute
  '/(practitioner)/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren
  '/(practitioner)/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute
  '/(practitioner)/practitioner/work-list': typeof practitionerPractitionerWorkListRoute
  '/(public)/disable-emails/$token': typeof publicDisableEmailsTokenRoute
  '/(practitioner)/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute
  '/(practitioner)/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren
  '/(practitioner)/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute
  '/(practitioner)/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute
  '/(practitioner)/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute
  '/(practitioner)/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute
  '/(practitioner)/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute
  '/(practitioner)/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute
  '/(practitioner)/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute
  '/(practitioner)/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute
  '/(patient)/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute
  '/(practitioner)/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute
  '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute
  '/(practitioner)/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute
  '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute
  '/(practitioner)/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute
  '/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId': typeof practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute
  '/(practitioner)/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app-home'
    | '/confirm'
    | '/confirm-account'
    | '/login'
    | '/patient-signup'
    | '/recover-password'
    | '/register'
    | '/reset-password'
    | '/diagnostic-reports'
    | '/documents'
    | '/encounters'
    | '/company'
    | '/patients'
    | '/legal'
    | '/support'
    | '/audit-log'
    | '/backup'
    | '/contact'
    | '/home'
    | '/logout'
    | '/notifications'
    | '/profile'
    | '/diagnostic-reports/$diagnosticReportId'
    | '/documents/create'
    | '/patient/diagnostic-report-request'
    | '/patient/diagnostic-report-sent'
    | '/patient/image-protocol-request'
    | '/patient/image-protocols'
    | '/patient/payment-orders'
    | '/patient/psoriasis-info'
    | '/company/inactive-company'
    | '/company/metrics'
    | '/company/pathology-customization'
    | '/company/practitioners'
    | '/image-protocol/image-protocol-request'
    | '/patients/$patientId'
    | '/patients/create'
    | '/practitioner/activity'
    | '/practitioner/diagnostic-report-request'
    | '/practitioner/diagnostic-report-sent'
    | '/practitioner/patient-payment-orders'
    | '/practitioner/quick-diagnostic-report-request'
    | '/practitioner/work-list'
    | '/disable-emails/$token'
    | '/company/pathology-customization/create'
    | '/company/practitioners/$practitionerId'
    | '/company/practitioners/create'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/patient-interactions'
    | '/patients/$patientId/recover-password'
    | '/patients/$patientId/terminate-study'
    | '/practitioner/activity/$date'
    | '/practitioner/patient-payment-orders/create'
    | '/practitioners/$practitionerId/recover-password'
    | '/patient/payment-orders/$paymentOrderId/pay'
    | '/company/pathology-customization/$pathologyId/edit'
    | '/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/company/practitioners/$practitionerId/delete'
    | '/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/patients/$patientId/encounters/$encounterId'
    | '/patients/$patientId/image-protocols/$imageProtocolId'
    | '/patients/$patientId/temporary-images/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app-home'
    | '/confirm'
    | '/confirm-account'
    | '/login'
    | '/patient-signup'
    | '/recover-password'
    | '/register'
    | '/reset-password'
    | '/diagnostic-reports'
    | '/documents'
    | '/encounters'
    | '/company'
    | '/patients'
    | '/legal'
    | '/support'
    | '/audit-log'
    | '/backup'
    | '/contact'
    | '/home'
    | '/logout'
    | '/notifications'
    | '/profile'
    | '/diagnostic-reports/$diagnosticReportId'
    | '/documents/create'
    | '/patient/diagnostic-report-request'
    | '/patient/diagnostic-report-sent'
    | '/patient/image-protocol-request'
    | '/patient/image-protocols'
    | '/patient/payment-orders'
    | '/patient/psoriasis-info'
    | '/company/inactive-company'
    | '/company/metrics'
    | '/company/pathology-customization'
    | '/company/practitioners'
    | '/image-protocol/image-protocol-request'
    | '/patients/$patientId'
    | '/patients/create'
    | '/practitioner/activity'
    | '/practitioner/diagnostic-report-request'
    | '/practitioner/diagnostic-report-sent'
    | '/practitioner/patient-payment-orders'
    | '/practitioner/quick-diagnostic-report-request'
    | '/practitioner/work-list'
    | '/disable-emails/$token'
    | '/company/pathology-customization/create'
    | '/company/practitioners/$practitionerId'
    | '/company/practitioners/create'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/patient-interactions'
    | '/patients/$patientId/recover-password'
    | '/patients/$patientId/terminate-study'
    | '/practitioner/activity/$date'
    | '/practitioner/patient-payment-orders/create'
    | '/practitioners/$practitionerId/recover-password'
    | '/patient/payment-orders/$paymentOrderId/pay'
    | '/company/pathology-customization/$pathologyId/edit'
    | '/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/company/practitioners/$practitionerId/delete'
    | '/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/patients/$patientId/encounters/$encounterId'
    | '/patients/$patientId/image-protocols/$imageProtocolId'
    | '/patients/$patientId/temporary-images/upload'
  id:
    | '__root__'
    | '/'
    | '/(anonymous)'
    | '/(patient)'
    | '/(practitioner)'
    | '/(public)'
    | '/(shared)'
    | '/(anonymous)/app-home'
    | '/(anonymous)/confirm'
    | '/(anonymous)/confirm-account'
    | '/(anonymous)/login'
    | '/(anonymous)/patient-signup'
    | '/(anonymous)/recover-password'
    | '/(anonymous)/register'
    | '/(anonymous)/reset-password'
    | '/(patient)/diagnostic-reports'
    | '/(patient)/documents'
    | '/(patient)/encounters'
    | '/(practitioner)/company'
    | '/(practitioner)/diagnostic-reports'
    | '/(practitioner)/patients'
    | '/(public)/legal'
    | '/(public)/support'
    | '/(shared)/audit-log'
    | '/(shared)/backup'
    | '/(shared)/contact'
    | '/(shared)/home'
    | '/(shared)/logout'
    | '/(shared)/notifications'
    | '/(shared)/profile'
    | '/(patient)/diagnostic-reports/$diagnosticReportId'
    | '/(patient)/documents/create'
    | '/(patient)/patient/diagnostic-report-request'
    | '/(patient)/patient/diagnostic-report-sent'
    | '/(patient)/patient/image-protocol-request'
    | '/(patient)/patient/image-protocols'
    | '/(patient)/patient/payment-orders'
    | '/(patient)/patient/psoriasis-info'
    | '/(practitioner)/company/inactive-company'
    | '/(practitioner)/company/metrics'
    | '/(practitioner)/company/pathology-customization'
    | '/(practitioner)/company/practitioners'
    | '/(practitioner)/image-protocol/image-protocol-request'
    | '/(practitioner)/patients/$patientId'
    | '/(practitioner)/patients/create'
    | '/(practitioner)/practitioner/activity'
    | '/(practitioner)/practitioner/diagnostic-report-request'
    | '/(practitioner)/practitioner/diagnostic-report-sent'
    | '/(practitioner)/practitioner/patient-payment-orders'
    | '/(practitioner)/practitioner/quick-diagnostic-report-request'
    | '/(practitioner)/practitioner/work-list'
    | '/(public)/disable-emails/$token'
    | '/(practitioner)/company/pathology-customization/create'
    | '/(practitioner)/company/practitioners/$practitionerId'
    | '/(practitioner)/company/practitioners/create'
    | '/(practitioner)/patients/$patientId/delete'
    | '/(practitioner)/patients/$patientId/patient-interactions'
    | '/(practitioner)/patients/$patientId/recover-password'
    | '/(practitioner)/patients/$patientId/terminate-study'
    | '/(practitioner)/practitioner/activity/$date'
    | '/(practitioner)/practitioner/patient-payment-orders/create'
    | '/(practitioner)/practitioners/$practitionerId/recover-password'
    | '/(patient)/patient/payment-orders/$paymentOrderId/pay'
    | '/(practitioner)/company/pathology-customization/$pathologyId/edit'
    | '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/(practitioner)/company/practitioners/$practitionerId/delete'
    | '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/(practitioner)/patients/$patientId/encounters/$encounterId'
    | '/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId'
    | '/(practitioner)/patients/$patientId/temporary-images/upload'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  anonymousRouteRoute: typeof anonymousRouteRouteWithChildren
  patientRouteRoute: typeof patientRouteRouteWithChildren
  practitionerRouteRoute: typeof practitionerRouteRouteWithChildren
  publicRouteRoute: typeof publicRouteRouteWithChildren
  sharedRouteRoute: typeof sharedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(shared)': {
      id: '/(shared)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof sharedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(practitioner)': {
      id: '/(practitioner)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof practitionerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(patient)': {
      id: '/(patient)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof patientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(anonymous)': {
      id: '/(anonymous)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof anonymousRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(shared)/profile': {
      id: '/(shared)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof sharedProfileRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/notifications': {
      id: '/(shared)/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof sharedNotificationsRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/logout': {
      id: '/(shared)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof sharedLogoutRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/home': {
      id: '/(shared)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof sharedHomeRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/contact': {
      id: '/(shared)/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof sharedContactRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/backup': {
      id: '/(shared)/backup'
      path: '/backup'
      fullPath: '/backup'
      preLoaderRoute: typeof sharedBackupRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(shared)/audit-log': {
      id: '/(shared)/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof sharedAuditLogRouteImport
      parentRoute: typeof sharedRouteRoute
    }
    '/(public)/support': {
      id: '/(public)/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof publicSupportRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/legal': {
      id: '/(public)/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof publicLegalRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(practitioner)/patients': {
      id: '/(practitioner)/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof practitionerPatientsRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/diagnostic-reports': {
      id: '/(practitioner)/diagnostic-reports'
      path: '/diagnostic-reports'
      fullPath: '/diagnostic-reports'
      preLoaderRoute: typeof practitionerDiagnosticReportsRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/company': {
      id: '/(practitioner)/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof practitionerCompanyRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(patient)/encounters': {
      id: '/(patient)/encounters'
      path: '/encounters'
      fullPath: '/encounters'
      preLoaderRoute: typeof patientEncountersRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/documents': {
      id: '/(patient)/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof patientDocumentsRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/diagnostic-reports': {
      id: '/(patient)/diagnostic-reports'
      path: '/diagnostic-reports'
      fullPath: '/diagnostic-reports'
      preLoaderRoute: typeof patientDiagnosticReportsRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(anonymous)/reset-password': {
      id: '/(anonymous)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof anonymousResetPasswordRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/register': {
      id: '/(anonymous)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof anonymousRegisterRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/recover-password': {
      id: '/(anonymous)/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof anonymousRecoverPasswordRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/patient-signup': {
      id: '/(anonymous)/patient-signup'
      path: '/patient-signup'
      fullPath: '/patient-signup'
      preLoaderRoute: typeof anonymousPatientSignupRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/login': {
      id: '/(anonymous)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof anonymousLoginRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/confirm-account': {
      id: '/(anonymous)/confirm-account'
      path: '/confirm-account'
      fullPath: '/confirm-account'
      preLoaderRoute: typeof anonymousConfirmAccountRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/confirm': {
      id: '/(anonymous)/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof anonymousConfirmRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(anonymous)/app-home': {
      id: '/(anonymous)/app-home'
      path: '/app-home'
      fullPath: '/app-home'
      preLoaderRoute: typeof anonymousAppHomeRouteImport
      parentRoute: typeof anonymousRouteRoute
    }
    '/(public)/disable-emails/$token': {
      id: '/(public)/disable-emails/$token'
      path: '/disable-emails/$token'
      fullPath: '/disable-emails/$token'
      preLoaderRoute: typeof publicDisableEmailsTokenRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(practitioner)/practitioner/work-list': {
      id: '/(practitioner)/practitioner/work-list'
      path: '/practitioner/work-list'
      fullPath: '/practitioner/work-list'
      preLoaderRoute: typeof practitionerPractitionerWorkListRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/quick-diagnostic-report-request': {
      id: '/(practitioner)/practitioner/quick-diagnostic-report-request'
      path: '/practitioner/quick-diagnostic-report-request'
      fullPath: '/practitioner/quick-diagnostic-report-request'
      preLoaderRoute: typeof practitionerPractitionerQuickDiagnosticReportRequestRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/patient-payment-orders': {
      id: '/(practitioner)/practitioner/patient-payment-orders'
      path: '/practitioner/patient-payment-orders'
      fullPath: '/practitioner/patient-payment-orders'
      preLoaderRoute: typeof practitionerPractitionerPatientPaymentOrdersRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/diagnostic-report-sent': {
      id: '/(practitioner)/practitioner/diagnostic-report-sent'
      path: '/practitioner/diagnostic-report-sent'
      fullPath: '/practitioner/diagnostic-report-sent'
      preLoaderRoute: typeof practitionerPractitionerDiagnosticReportSentRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/diagnostic-report-request': {
      id: '/(practitioner)/practitioner/diagnostic-report-request'
      path: '/practitioner/diagnostic-report-request'
      fullPath: '/practitioner/diagnostic-report-request'
      preLoaderRoute: typeof practitionerPractitionerDiagnosticReportRequestRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/activity': {
      id: '/(practitioner)/practitioner/activity'
      path: '/practitioner/activity'
      fullPath: '/practitioner/activity'
      preLoaderRoute: typeof practitionerPractitionerActivityRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/patients/create': {
      id: '/(practitioner)/patients/create'
      path: '/create'
      fullPath: '/patients/create'
      preLoaderRoute: typeof practitionerPatientsCreateRouteImport
      parentRoute: typeof practitionerPatientsRoute
    }
    '/(practitioner)/patients/$patientId': {
      id: '/(practitioner)/patients/$patientId'
      path: '/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof practitionerPatientsPatientIdRouteImport
      parentRoute: typeof practitionerPatientsRoute
    }
    '/(practitioner)/image-protocol/image-protocol-request': {
      id: '/(practitioner)/image-protocol/image-protocol-request'
      path: '/image-protocol/image-protocol-request'
      fullPath: '/image-protocol/image-protocol-request'
      preLoaderRoute: typeof practitionerImageProtocolImageProtocolRequestRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/company/practitioners': {
      id: '/(practitioner)/company/practitioners'
      path: '/practitioners'
      fullPath: '/company/practitioners'
      preLoaderRoute: typeof practitionerCompanyPractitionersRouteImport
      parentRoute: typeof practitionerCompanyRoute
    }
    '/(practitioner)/company/pathology-customization': {
      id: '/(practitioner)/company/pathology-customization'
      path: '/pathology-customization'
      fullPath: '/company/pathology-customization'
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationRouteImport
      parentRoute: typeof practitionerCompanyRoute
    }
    '/(practitioner)/company/metrics': {
      id: '/(practitioner)/company/metrics'
      path: '/metrics'
      fullPath: '/company/metrics'
      preLoaderRoute: typeof practitionerCompanyMetricsRouteImport
      parentRoute: typeof practitionerCompanyRoute
    }
    '/(practitioner)/company/inactive-company': {
      id: '/(practitioner)/company/inactive-company'
      path: '/inactive-company'
      fullPath: '/company/inactive-company'
      preLoaderRoute: typeof practitionerCompanyInactiveCompanyRouteImport
      parentRoute: typeof practitionerCompanyRoute
    }
    '/(patient)/patient/psoriasis-info': {
      id: '/(patient)/patient/psoriasis-info'
      path: '/patient/psoriasis-info'
      fullPath: '/patient/psoriasis-info'
      preLoaderRoute: typeof patientPatientPsoriasisInfoRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/patient/payment-orders': {
      id: '/(patient)/patient/payment-orders'
      path: '/patient/payment-orders'
      fullPath: '/patient/payment-orders'
      preLoaderRoute: typeof patientPatientPaymentOrdersRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/patient/image-protocols': {
      id: '/(patient)/patient/image-protocols'
      path: '/patient/image-protocols'
      fullPath: '/patient/image-protocols'
      preLoaderRoute: typeof patientPatientImageProtocolsRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/patient/image-protocol-request': {
      id: '/(patient)/patient/image-protocol-request'
      path: '/patient/image-protocol-request'
      fullPath: '/patient/image-protocol-request'
      preLoaderRoute: typeof patientPatientImageProtocolRequestRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/patient/diagnostic-report-sent': {
      id: '/(patient)/patient/diagnostic-report-sent'
      path: '/patient/diagnostic-report-sent'
      fullPath: '/patient/diagnostic-report-sent'
      preLoaderRoute: typeof patientPatientDiagnosticReportSentRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/patient/diagnostic-report-request': {
      id: '/(patient)/patient/diagnostic-report-request'
      path: '/patient/diagnostic-report-request'
      fullPath: '/patient/diagnostic-report-request'
      preLoaderRoute: typeof patientPatientDiagnosticReportRequestRouteImport
      parentRoute: typeof patientRouteRoute
    }
    '/(patient)/documents/create': {
      id: '/(patient)/documents/create'
      path: '/create'
      fullPath: '/documents/create'
      preLoaderRoute: typeof patientDocumentsCreateRouteImport
      parentRoute: typeof patientDocumentsRoute
    }
    '/(patient)/diagnostic-reports/$diagnosticReportId': {
      id: '/(patient)/diagnostic-reports/$diagnosticReportId'
      path: '/$diagnosticReportId'
      fullPath: '/diagnostic-reports/$diagnosticReportId'
      preLoaderRoute: typeof patientDiagnosticReportsDiagnosticReportIdRouteImport
      parentRoute: typeof patientDiagnosticReportsRoute
    }
    '/(practitioner)/practitioners/$practitionerId/recover-password': {
      id: '/(practitioner)/practitioners/$practitionerId/recover-password'
      path: '/practitioners/$practitionerId/recover-password'
      fullPath: '/practitioners/$practitionerId/recover-password'
      preLoaderRoute: typeof practitionerPractitionersPractitionerIdRecoverPasswordRouteImport
      parentRoute: typeof practitionerRouteRoute
    }
    '/(practitioner)/practitioner/patient-payment-orders/create': {
      id: '/(practitioner)/practitioner/patient-payment-orders/create'
      path: '/create'
      fullPath: '/practitioner/patient-payment-orders/create'
      preLoaderRoute: typeof practitionerPractitionerPatientPaymentOrdersCreateRouteImport
      parentRoute: typeof practitionerPractitionerPatientPaymentOrdersRoute
    }
    '/(practitioner)/practitioner/activity/$date': {
      id: '/(practitioner)/practitioner/activity/$date'
      path: '/$date'
      fullPath: '/practitioner/activity/$date'
      preLoaderRoute: typeof practitionerPractitionerActivityDateRouteImport
      parentRoute: typeof practitionerPractitionerActivityRoute
    }
    '/(practitioner)/patients/$patientId/terminate-study': {
      id: '/(practitioner)/patients/$patientId/terminate-study'
      path: '/terminate-study'
      fullPath: '/patients/$patientId/terminate-study'
      preLoaderRoute: typeof practitionerPatientsPatientIdTerminateStudyRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/recover-password': {
      id: '/(practitioner)/patients/$patientId/recover-password'
      path: '/recover-password'
      fullPath: '/patients/$patientId/recover-password'
      preLoaderRoute: typeof practitionerPatientsPatientIdRecoverPasswordRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/patient-interactions': {
      id: '/(practitioner)/patients/$patientId/patient-interactions'
      path: '/patient-interactions'
      fullPath: '/patients/$patientId/patient-interactions'
      preLoaderRoute: typeof practitionerPatientsPatientIdPatientInteractionsRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/delete': {
      id: '/(practitioner)/patients/$patientId/delete'
      path: '/delete'
      fullPath: '/patients/$patientId/delete'
      preLoaderRoute: typeof practitionerPatientsPatientIdDeleteRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/company/practitioners/create': {
      id: '/(practitioner)/company/practitioners/create'
      path: '/create'
      fullPath: '/company/practitioners/create'
      preLoaderRoute: typeof practitionerCompanyPractitionersCreateRouteImport
      parentRoute: typeof practitionerCompanyPractitionersRoute
    }
    '/(practitioner)/company/practitioners/$practitionerId': {
      id: '/(practitioner)/company/practitioners/$practitionerId'
      path: '/$practitionerId'
      fullPath: '/company/practitioners/$practitionerId'
      preLoaderRoute: typeof practitionerCompanyPractitionersPractitionerIdRouteImport
      parentRoute: typeof practitionerCompanyPractitionersRoute
    }
    '/(practitioner)/company/pathology-customization/create': {
      id: '/(practitioner)/company/pathology-customization/create'
      path: '/create'
      fullPath: '/company/pathology-customization/create'
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationCreateRouteImport
      parentRoute: typeof practitionerCompanyPathologyCustomizationRoute
    }
    '/(practitioner)/patients/$patientId/temporary-images/upload': {
      id: '/(practitioner)/patients/$patientId/temporary-images/upload'
      path: '/temporary-images/upload'
      fullPath: '/patients/$patientId/temporary-images/upload'
      preLoaderRoute: typeof practitionerPatientsPatientIdTemporaryImagesUploadRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId': {
      id: '/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId'
      path: '/image-protocols/$imageProtocolId'
      fullPath: '/patients/$patientId/image-protocols/$imageProtocolId'
      preLoaderRoute: typeof practitionerPatientsPatientIdImageProtocolsImageProtocolIdRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/encounters/$encounterId': {
      id: '/(practitioner)/patients/$patientId/encounters/$encounterId'
      path: '/encounters/$encounterId'
      fullPath: '/patients/$patientId/encounters/$encounterId'
      preLoaderRoute: typeof practitionerPatientsPatientIdEncountersEncounterIdRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId': {
      id: '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId'
      path: '/diagnostic-report/$diagnosticReportId'
      fullPath: '/patients/$patientId/diagnostic-report/$diagnosticReportId'
      preLoaderRoute: typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRouteImport
      parentRoute: typeof practitionerPatientsPatientIdRoute
    }
    '/(practitioner)/company/practitioners/$practitionerId/delete': {
      id: '/(practitioner)/company/practitioners/$practitionerId/delete'
      path: '/delete'
      fullPath: '/company/practitioners/$practitionerId/delete'
      preLoaderRoute: typeof practitionerCompanyPractitionersPractitionerIdDeleteRouteImport
      parentRoute: typeof practitionerCompanyPractitionersPractitionerIdRoute
    }
    '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete': {
      id: '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete'
      path: '/pathology-overrides/$pathologyOverrideId/delete'
      fullPath: '/company/pathology-overrides/$pathologyOverrideId/delete'
      preLoaderRoute: typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRouteImport
      parentRoute: typeof practitionerCompanyRoute
    }
    '/(practitioner)/company/pathology-customization/$pathologyId/edit': {
      id: '/(practitioner)/company/pathology-customization/$pathologyId/edit'
      path: '/$pathologyId/edit'
      fullPath: '/company/pathology-customization/$pathologyId/edit'
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationPathologyIdEditRouteImport
      parentRoute: typeof practitionerCompanyPathologyCustomizationRoute
    }
    '/(patient)/patient/payment-orders/$paymentOrderId/pay': {
      id: '/(patient)/patient/payment-orders/$paymentOrderId/pay'
      path: '/$paymentOrderId/pay'
      fullPath: '/patient/payment-orders/$paymentOrderId/pay'
      preLoaderRoute: typeof patientPatientPaymentOrdersPaymentOrderIdPayRouteImport
      parentRoute: typeof patientPatientPaymentOrdersRoute
    }
  }
}

interface anonymousRouteRouteChildren {
  anonymousAppHomeRoute: typeof anonymousAppHomeRoute
  anonymousConfirmRoute: typeof anonymousConfirmRoute
  anonymousConfirmAccountRoute: typeof anonymousConfirmAccountRoute
  anonymousLoginRoute: typeof anonymousLoginRoute
  anonymousPatientSignupRoute: typeof anonymousPatientSignupRoute
  anonymousRecoverPasswordRoute: typeof anonymousRecoverPasswordRoute
  anonymousRegisterRoute: typeof anonymousRegisterRoute
  anonymousResetPasswordRoute: typeof anonymousResetPasswordRoute
}

const anonymousRouteRouteChildren: anonymousRouteRouteChildren = {
  anonymousAppHomeRoute: anonymousAppHomeRoute,
  anonymousConfirmRoute: anonymousConfirmRoute,
  anonymousConfirmAccountRoute: anonymousConfirmAccountRoute,
  anonymousLoginRoute: anonymousLoginRoute,
  anonymousPatientSignupRoute: anonymousPatientSignupRoute,
  anonymousRecoverPasswordRoute: anonymousRecoverPasswordRoute,
  anonymousRegisterRoute: anonymousRegisterRoute,
  anonymousResetPasswordRoute: anonymousResetPasswordRoute,
}

const anonymousRouteRouteWithChildren = anonymousRouteRoute._addFileChildren(
  anonymousRouteRouteChildren,
)

interface patientDiagnosticReportsRouteChildren {
  patientDiagnosticReportsDiagnosticReportIdRoute: typeof patientDiagnosticReportsDiagnosticReportIdRoute
}

const patientDiagnosticReportsRouteChildren: patientDiagnosticReportsRouteChildren =
  {
    patientDiagnosticReportsDiagnosticReportIdRoute:
      patientDiagnosticReportsDiagnosticReportIdRoute,
  }

const patientDiagnosticReportsRouteWithChildren =
  patientDiagnosticReportsRoute._addFileChildren(
    patientDiagnosticReportsRouteChildren,
  )

interface patientDocumentsRouteChildren {
  patientDocumentsCreateRoute: typeof patientDocumentsCreateRoute
}

const patientDocumentsRouteChildren: patientDocumentsRouteChildren = {
  patientDocumentsCreateRoute: patientDocumentsCreateRoute,
}

const patientDocumentsRouteWithChildren =
  patientDocumentsRoute._addFileChildren(patientDocumentsRouteChildren)

interface patientPatientPaymentOrdersRouteChildren {
  patientPatientPaymentOrdersPaymentOrderIdPayRoute: typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute
}

const patientPatientPaymentOrdersRouteChildren: patientPatientPaymentOrdersRouteChildren =
  {
    patientPatientPaymentOrdersPaymentOrderIdPayRoute:
      patientPatientPaymentOrdersPaymentOrderIdPayRoute,
  }

const patientPatientPaymentOrdersRouteWithChildren =
  patientPatientPaymentOrdersRoute._addFileChildren(
    patientPatientPaymentOrdersRouteChildren,
  )

interface patientRouteRouteChildren {
  patientDiagnosticReportsRoute: typeof patientDiagnosticReportsRouteWithChildren
  patientDocumentsRoute: typeof patientDocumentsRouteWithChildren
  patientEncountersRoute: typeof patientEncountersRoute
  patientPatientDiagnosticReportRequestRoute: typeof patientPatientDiagnosticReportRequestRoute
  patientPatientDiagnosticReportSentRoute: typeof patientPatientDiagnosticReportSentRoute
  patientPatientImageProtocolRequestRoute: typeof patientPatientImageProtocolRequestRoute
  patientPatientImageProtocolsRoute: typeof patientPatientImageProtocolsRoute
  patientPatientPaymentOrdersRoute: typeof patientPatientPaymentOrdersRouteWithChildren
  patientPatientPsoriasisInfoRoute: typeof patientPatientPsoriasisInfoRoute
}

const patientRouteRouteChildren: patientRouteRouteChildren = {
  patientDiagnosticReportsRoute: patientDiagnosticReportsRouteWithChildren,
  patientDocumentsRoute: patientDocumentsRouteWithChildren,
  patientEncountersRoute: patientEncountersRoute,
  patientPatientDiagnosticReportRequestRoute:
    patientPatientDiagnosticReportRequestRoute,
  patientPatientDiagnosticReportSentRoute:
    patientPatientDiagnosticReportSentRoute,
  patientPatientImageProtocolRequestRoute:
    patientPatientImageProtocolRequestRoute,
  patientPatientImageProtocolsRoute: patientPatientImageProtocolsRoute,
  patientPatientPaymentOrdersRoute:
    patientPatientPaymentOrdersRouteWithChildren,
  patientPatientPsoriasisInfoRoute: patientPatientPsoriasisInfoRoute,
}

const patientRouteRouteWithChildren = patientRouteRoute._addFileChildren(
  patientRouteRouteChildren,
)

interface practitionerCompanyPathologyCustomizationRouteChildren {
  practitionerCompanyPathologyCustomizationCreateRoute: typeof practitionerCompanyPathologyCustomizationCreateRoute
  practitionerCompanyPathologyCustomizationPathologyIdEditRoute: typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute
}

const practitionerCompanyPathologyCustomizationRouteChildren: practitionerCompanyPathologyCustomizationRouteChildren =
  {
    practitionerCompanyPathologyCustomizationCreateRoute:
      practitionerCompanyPathologyCustomizationCreateRoute,
    practitionerCompanyPathologyCustomizationPathologyIdEditRoute:
      practitionerCompanyPathologyCustomizationPathologyIdEditRoute,
  }

const practitionerCompanyPathologyCustomizationRouteWithChildren =
  practitionerCompanyPathologyCustomizationRoute._addFileChildren(
    practitionerCompanyPathologyCustomizationRouteChildren,
  )

interface practitionerCompanyPractitionersPractitionerIdRouteChildren {
  practitionerCompanyPractitionersPractitionerIdDeleteRoute: typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute
}

const practitionerCompanyPractitionersPractitionerIdRouteChildren: practitionerCompanyPractitionersPractitionerIdRouteChildren =
  {
    practitionerCompanyPractitionersPractitionerIdDeleteRoute:
      practitionerCompanyPractitionersPractitionerIdDeleteRoute,
  }

const practitionerCompanyPractitionersPractitionerIdRouteWithChildren =
  practitionerCompanyPractitionersPractitionerIdRoute._addFileChildren(
    practitionerCompanyPractitionersPractitionerIdRouteChildren,
  )

interface practitionerCompanyPractitionersRouteChildren {
  practitionerCompanyPractitionersPractitionerIdRoute: typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren
  practitionerCompanyPractitionersCreateRoute: typeof practitionerCompanyPractitionersCreateRoute
}

const practitionerCompanyPractitionersRouteChildren: practitionerCompanyPractitionersRouteChildren =
  {
    practitionerCompanyPractitionersPractitionerIdRoute:
      practitionerCompanyPractitionersPractitionerIdRouteWithChildren,
    practitionerCompanyPractitionersCreateRoute:
      practitionerCompanyPractitionersCreateRoute,
  }

const practitionerCompanyPractitionersRouteWithChildren =
  practitionerCompanyPractitionersRoute._addFileChildren(
    practitionerCompanyPractitionersRouteChildren,
  )

interface practitionerCompanyRouteChildren {
  practitionerCompanyInactiveCompanyRoute: typeof practitionerCompanyInactiveCompanyRoute
  practitionerCompanyMetricsRoute: typeof practitionerCompanyMetricsRoute
  practitionerCompanyPathologyCustomizationRoute: typeof practitionerCompanyPathologyCustomizationRouteWithChildren
  practitionerCompanyPractitionersRoute: typeof practitionerCompanyPractitionersRouteWithChildren
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute: typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute
}

const practitionerCompanyRouteChildren: practitionerCompanyRouteChildren = {
  practitionerCompanyInactiveCompanyRoute:
    practitionerCompanyInactiveCompanyRoute,
  practitionerCompanyMetricsRoute: practitionerCompanyMetricsRoute,
  practitionerCompanyPathologyCustomizationRoute:
    practitionerCompanyPathologyCustomizationRouteWithChildren,
  practitionerCompanyPractitionersRoute:
    practitionerCompanyPractitionersRouteWithChildren,
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute:
    practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute,
}

const practitionerCompanyRouteWithChildren =
  practitionerCompanyRoute._addFileChildren(practitionerCompanyRouteChildren)

interface practitionerPatientsPatientIdRouteChildren {
  practitionerPatientsPatientIdDeleteRoute: typeof practitionerPatientsPatientIdDeleteRoute
  practitionerPatientsPatientIdPatientInteractionsRoute: typeof practitionerPatientsPatientIdPatientInteractionsRoute
  practitionerPatientsPatientIdRecoverPasswordRoute: typeof practitionerPatientsPatientIdRecoverPasswordRoute
  practitionerPatientsPatientIdTerminateStudyRoute: typeof practitionerPatientsPatientIdTerminateStudyRoute
  practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute: typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute
  practitionerPatientsPatientIdEncountersEncounterIdRoute: typeof practitionerPatientsPatientIdEncountersEncounterIdRoute
  practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute: typeof practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute
  practitionerPatientsPatientIdTemporaryImagesUploadRoute: typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute
}

const practitionerPatientsPatientIdRouteChildren: practitionerPatientsPatientIdRouteChildren =
  {
    practitionerPatientsPatientIdDeleteRoute:
      practitionerPatientsPatientIdDeleteRoute,
    practitionerPatientsPatientIdPatientInteractionsRoute:
      practitionerPatientsPatientIdPatientInteractionsRoute,
    practitionerPatientsPatientIdRecoverPasswordRoute:
      practitionerPatientsPatientIdRecoverPasswordRoute,
    practitionerPatientsPatientIdTerminateStudyRoute:
      practitionerPatientsPatientIdTerminateStudyRoute,
    practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute:
      practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute,
    practitionerPatientsPatientIdEncountersEncounterIdRoute:
      practitionerPatientsPatientIdEncountersEncounterIdRoute,
    practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute:
      practitionerPatientsPatientIdImageProtocolsImageProtocolIdRoute,
    practitionerPatientsPatientIdTemporaryImagesUploadRoute:
      practitionerPatientsPatientIdTemporaryImagesUploadRoute,
  }

const practitionerPatientsPatientIdRouteWithChildren =
  practitionerPatientsPatientIdRoute._addFileChildren(
    practitionerPatientsPatientIdRouteChildren,
  )

interface practitionerPatientsRouteChildren {
  practitionerPatientsPatientIdRoute: typeof practitionerPatientsPatientIdRouteWithChildren
  practitionerPatientsCreateRoute: typeof practitionerPatientsCreateRoute
}

const practitionerPatientsRouteChildren: practitionerPatientsRouteChildren = {
  practitionerPatientsPatientIdRoute:
    practitionerPatientsPatientIdRouteWithChildren,
  practitionerPatientsCreateRoute: practitionerPatientsCreateRoute,
}

const practitionerPatientsRouteWithChildren =
  practitionerPatientsRoute._addFileChildren(practitionerPatientsRouteChildren)

interface practitionerPractitionerActivityRouteChildren {
  practitionerPractitionerActivityDateRoute: typeof practitionerPractitionerActivityDateRoute
}

const practitionerPractitionerActivityRouteChildren: practitionerPractitionerActivityRouteChildren =
  {
    practitionerPractitionerActivityDateRoute:
      practitionerPractitionerActivityDateRoute,
  }

const practitionerPractitionerActivityRouteWithChildren =
  practitionerPractitionerActivityRoute._addFileChildren(
    practitionerPractitionerActivityRouteChildren,
  )

interface practitionerPractitionerPatientPaymentOrdersRouteChildren {
  practitionerPractitionerPatientPaymentOrdersCreateRoute: typeof practitionerPractitionerPatientPaymentOrdersCreateRoute
}

const practitionerPractitionerPatientPaymentOrdersRouteChildren: practitionerPractitionerPatientPaymentOrdersRouteChildren =
  {
    practitionerPractitionerPatientPaymentOrdersCreateRoute:
      practitionerPractitionerPatientPaymentOrdersCreateRoute,
  }

const practitionerPractitionerPatientPaymentOrdersRouteWithChildren =
  practitionerPractitionerPatientPaymentOrdersRoute._addFileChildren(
    practitionerPractitionerPatientPaymentOrdersRouteChildren,
  )

interface practitionerRouteRouteChildren {
  practitionerCompanyRoute: typeof practitionerCompanyRouteWithChildren
  practitionerDiagnosticReportsRoute: typeof practitionerDiagnosticReportsRoute
  practitionerPatientsRoute: typeof practitionerPatientsRouteWithChildren
  practitionerImageProtocolImageProtocolRequestRoute: typeof practitionerImageProtocolImageProtocolRequestRoute
  practitionerPractitionerActivityRoute: typeof practitionerPractitionerActivityRouteWithChildren
  practitionerPractitionerDiagnosticReportRequestRoute: typeof practitionerPractitionerDiagnosticReportRequestRoute
  practitionerPractitionerDiagnosticReportSentRoute: typeof practitionerPractitionerDiagnosticReportSentRoute
  practitionerPractitionerPatientPaymentOrdersRoute: typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren
  practitionerPractitionerQuickDiagnosticReportRequestRoute: typeof practitionerPractitionerQuickDiagnosticReportRequestRoute
  practitionerPractitionerWorkListRoute: typeof practitionerPractitionerWorkListRoute
  practitionerPractitionersPractitionerIdRecoverPasswordRoute: typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute
}

const practitionerRouteRouteChildren: practitionerRouteRouteChildren = {
  practitionerCompanyRoute: practitionerCompanyRouteWithChildren,
  practitionerDiagnosticReportsRoute: practitionerDiagnosticReportsRoute,
  practitionerPatientsRoute: practitionerPatientsRouteWithChildren,
  practitionerImageProtocolImageProtocolRequestRoute:
    practitionerImageProtocolImageProtocolRequestRoute,
  practitionerPractitionerActivityRoute:
    practitionerPractitionerActivityRouteWithChildren,
  practitionerPractitionerDiagnosticReportRequestRoute:
    practitionerPractitionerDiagnosticReportRequestRoute,
  practitionerPractitionerDiagnosticReportSentRoute:
    practitionerPractitionerDiagnosticReportSentRoute,
  practitionerPractitionerPatientPaymentOrdersRoute:
    practitionerPractitionerPatientPaymentOrdersRouteWithChildren,
  practitionerPractitionerQuickDiagnosticReportRequestRoute:
    practitionerPractitionerQuickDiagnosticReportRequestRoute,
  practitionerPractitionerWorkListRoute: practitionerPractitionerWorkListRoute,
  practitionerPractitionersPractitionerIdRecoverPasswordRoute:
    practitionerPractitionersPractitionerIdRecoverPasswordRoute,
}

const practitionerRouteRouteWithChildren =
  practitionerRouteRoute._addFileChildren(practitionerRouteRouteChildren)

interface publicRouteRouteChildren {
  publicLegalRoute: typeof publicLegalRoute
  publicSupportRoute: typeof publicSupportRoute
  publicDisableEmailsTokenRoute: typeof publicDisableEmailsTokenRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicLegalRoute: publicLegalRoute,
  publicSupportRoute: publicSupportRoute,
  publicDisableEmailsTokenRoute: publicDisableEmailsTokenRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface sharedRouteRouteChildren {
  sharedAuditLogRoute: typeof sharedAuditLogRoute
  sharedBackupRoute: typeof sharedBackupRoute
  sharedContactRoute: typeof sharedContactRoute
  sharedHomeRoute: typeof sharedHomeRoute
  sharedLogoutRoute: typeof sharedLogoutRoute
  sharedNotificationsRoute: typeof sharedNotificationsRoute
  sharedProfileRoute: typeof sharedProfileRoute
}

const sharedRouteRouteChildren: sharedRouteRouteChildren = {
  sharedAuditLogRoute: sharedAuditLogRoute,
  sharedBackupRoute: sharedBackupRoute,
  sharedContactRoute: sharedContactRoute,
  sharedHomeRoute: sharedHomeRoute,
  sharedLogoutRoute: sharedLogoutRoute,
  sharedNotificationsRoute: sharedNotificationsRoute,
  sharedProfileRoute: sharedProfileRoute,
}

const sharedRouteRouteWithChildren = sharedRouteRoute._addFileChildren(
  sharedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  anonymousRouteRoute: anonymousRouteRouteWithChildren,
  patientRouteRoute: patientRouteRouteWithChildren,
  practitionerRouteRoute: practitionerRouteRouteWithChildren,
  publicRouteRoute: publicRouteRouteWithChildren,
  sharedRouteRoute: sharedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
